import { useState, useEffect } from 'react';
import { throttleToAnimationFrame } from '@utils/common';

const NAVIGATION_BAR_HEIGHT = 120;
const STICKY_PADDING_TOP = 30;
function useHigherThanViewport(elementRef) {
  const [isHigher, setIsHigher] = useState(false);
  useEffect(() => {
    const element = elementRef.current;
    const updateElementHigher = () => {
      if (!element) {
        return;
      }
      if (element.clientHeight > window.innerHeight - NAVIGATION_BAR_HEIGHT - STICKY_PADDING_TOP) {
        setIsHigher(true);
        return;
      }
      setIsHigher(false);
    };
    updateElementHigher();
    setTimeout(updateElementHigher, 100);
    const throttled = throttleToAnimationFrame(updateElementHigher);
    window.addEventListener("resize", throttled);
    window.addEventListener("orientationchange", throttled);
    return () => {
      window.removeEventListener("resize", throttled);
      window.removeEventListener("orientationchange", throttled);
    };
  }, [elementRef]);
  return isHigher;
}

export { useHigherThanViewport };
//# sourceMappingURL=hook.higher-than-viewport.js.map
